<div *ngIf="reportData" class="data-toolbar">
  <span class="entity-records-info">
    <span class="entity-list">
      {{ 'user.' + reportData.entity | xTranslate }}
      {{ 'template.list' | xTranslate | titlecase }} &nbsp;&nbsp;&nbsp;
      {{ reportData?.records?.length }}
    </span>
    <ng-container *ngIf="reportData.records.length > 1; else singleRecord">
      {{ 'recordPPT.records' | xTranslate }}
    </ng-container>
    <ng-template #singleRecord>
      {{ 'recordPPT.record' | xTranslate }}
    </ng-template>
  </span>
  <span *ngIf="!isUKFeaturesEnabled">
    <a class="action-element" (click)="customizeColumns.emit(reportData.entity)">
      <mat-icon svgIcon="settings" aria-hidden="false"></mat-icon>
      <span l10nTranslate>template.customizeColumns</span>
    </a>
  </span>
</div>
